"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusIcon = exports.statusContainer = void 0;

var _reactEmotion = require("react-emotion");

var statusContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;align-items:center;");
exports.statusContainer = statusContainer;
var statusIcon =
/*#__PURE__*/
(0, _reactEmotion.css)("width:12px;height:12px;color:#424c59;fill:#424c59;margin-right:18px;");
exports.statusIcon = statusIcon;